import React from "react";

export interface LegalSection {
  heading: string;
  body: React.ReactNode;
}

export const LegalPage: React.FC<{
  title: string;
  lastUpdated: string;
  intro: string;
  sections: LegalSection[];
}> = ({ title, lastUpdated, intro, sections }) => {
  return (
    <div className="min-h-screen bg-slate-50 text-slate-900 pt-28 pb-20">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <header className="mb-10 border-b border-slate-200 pb-6">
          <span className="text-xs font-extrabold uppercase tracking-widest text-primary bg-primary/10 px-3 py-1 rounded-md">
            Legal &amp; Compliance
          </span>
          <h1 className="text-3xl sm:text-4xl font-extrabold text-slate-900 mt-4 tracking-tight">
            {title}
          </h1>
          <p className="text-sm text-slate-700 mt-2">
            Last updated: {lastUpdated}
          </p>
        </header>

        <p className="text-slate-700 leading-relaxed mb-10">{intro}</p>

        <div className="space-y-8">
          {sections.map((section, idx) => (
            <section key={idx}>
              <h2 className="text-xl font-bold text-slate-900 mb-3">
                {section.heading}
              </h2>
              <div className="text-slate-700 leading-relaxed text-sm space-y-3">
                {section.body}
              </div>
            </section>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-slate-200 text-sm text-slate-700">
          <p>
            For questions about this policy, contact Feingold Property
            Management, LLC at{" "}
            <a
              href="mailto:info@feingoldpm.com"
              className="font-semibold text-primary underline"
            >
              info@feingoldpm.com
            </a>{" "}
            or{" "}
            <a
              href="tel:+12407620106"
              className="font-semibold text-primary underline"
            >
              (240) 762-0106
            </a>
            .
          </p>
        </div>
      </div>
    </div>
  );
};
